var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col items-center justify-center gap-y-[10px] my-[32px]",class:`h-[${_vm.height.toString()}px]`},[_c('MapsIcon',{staticClass:"text-primary",attrs:{"width":"101","height":"100"}}),_c('span',{staticClass:"text-[#747B83] font-[300] text-[16px]"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }